<script>
    import { onMount } from 'svelte';
    import {notifier} from '@beyonk/svelte-notifications';

    import CodeEditor from './CodeEditor.svelte';

    export let assessment_type;
    export let assessment_type_model;
    
    let details;
    onMount(() => {
        const unsub = assessment_type.subscribe((value) => {
            details = value.details;

            if (!details.global_css) {
                details.global_css = " \n \n "
            }
        });

        return unsub;
    })

    function save() {
        assessment_type_model.saveDetails(details).then(() => {
            notifier.success("CSS Saved");
        })
    }
</script>

<h1 class="title is-1">
    Edit Global Report CSS
    <button class="button is-success is-pulled-right" on:click={save}>Save CSS</button>
</h1>

{#if details}
    <CodeEditor lang="css" bind:value={details.global_css}></CodeEditor>
{/if}